exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".camera-capture-input{padding-top:40px;height:500px;width:680px;margin:auto}.camera-capture-input .section{margin:auto;width:640px;display:flex;flex-direction:column}.camera-capture-input .top-controls{display:flex;flex-direction:column;margin-bottom:1rem;gap:1rem}.camera-capture-input .controls{margin-top:1rem;display:flex;flex-direction:row;align-content:center;justify-content:center;flex-grow:1;gap:1rem}.camera-capture-input .mirrored{transform:scaleX(-1)}.camera-capture-input .loading{display:flex;justify-content:center;align-items:center}", ""]);

// exports
